import { FahrlehrerCh } from '@/src/@types/blinkadmin'
import { flchUrl, get } from '@/src/BlinkAdminApiClient'

export type CantonCode =
  | 'ag'
  | 'ai'
  | 'ar'
  | 'be'
  | 'bl'
  | 'bs'
  | 'fr'
  | 'ge'
  | 'gl'
  | 'gr'
  | 'ju'
  | 'lu'
  | 'ne'
  | 'nw'
  | 'ow'
  | 'sg'
  | 'sh'
  | 'so'
  | 'sz'
  | 'tg'
  | 'ti'
  | 'ur'
  | 'vd'
  | 'vs'
  | 'zg'
  | 'zh'

export type CantonPrices = FahrlehrerCh.CantonPrices

export type PricesResponse = Partial<Record<CantonCode, CantonPrices>>

export const CANTONS: { code: CantonCode; name: string }[] = [
  { code: 'ag', name: 'Aargau' },
  { code: 'ai', name: 'Appenzell Innerrhoden' },
  { code: 'ar', name: 'Appenzell Ausserrhoden' },
  { code: 'be', name: 'Bern' },
  { code: 'bl', name: 'Basel-Landschaft' },
  { code: 'bs', name: 'Basel-Stadt' },
  { code: 'fr', name: 'Freiburg' },
  { code: 'ge', name: 'Genf' },
  { code: 'gl', name: 'Glarus' },
  { code: 'gr', name: 'Graubünden' },
  { code: 'ju', name: 'Jura' },
  { code: 'lu', name: 'Luzern' },
  { code: 'ne', name: 'Neuenburg' },
  { code: 'nw', name: 'Nidwalden' },
  { code: 'ow', name: 'Obwalden' },
  { code: 'sg', name: 'St. Gallen' },
  { code: 'sh', name: 'Schaffhausen' },
  { code: 'so', name: 'Solothurn' },
  { code: 'sz', name: 'Schwyz' },
  { code: 'tg', name: 'Thurgau' },
  { code: 'ti', name: 'Tessin' },
  { code: 'ur', name: 'Uri' },
  { code: 'vd', name: 'Waadt' },
  { code: 'vs', name: 'Wallis' },
  { code: 'zg', name: 'Zug' },
  { code: 'zh', name: 'Zürich' },
]

function toChf(prices: CantonPrices): CantonPrices {
  return Object.fromEntries(
    Object.entries(prices).map(([key, amount]) => [key, amount / 100])
  ) as CantonPrices
}

export async function getPrices(): Promise<PricesResponse> {
  const prices = await get<PricesResponse>(flchUrl('prices'))

  return Object.fromEntries(
    Object.entries(prices ?? {}).map(([code, cantonPrices]) => [
      code,
      toChf(cantonPrices),
    ])
  )
}
